import React, { useState, useEffect, useMemo } from 'react';
import { useReactToPrint } from 'react-to-print';
import { connect } from 'react-redux';
import { createURL } from 'utils';
import { request } from 'axios/request.js';
import { groupPackagesByMerchant } from 'utils';
import { objectSelector } from 'theme/utils';

const $P = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/packageOrderDetail`);

let _content = null;

const PrintButton = ({
  selectedFilterAttrs,
  selectedRowKeys,
  statusId,
  enumValue,
  url,
  sortingFilter = {},
  queryObject = {},
}) => {
  const componentRef = React.useRef(null);
  const [loading, setLoading] = useState(false);
  const [modalReady, setModalReady] = useState(false);
  const [data, setData] = useState([]);
  const [uncheckedList, setUncheckedList] = useState({});

  const reactToPrintContent = React.useCallback(() => {
    return componentRef.current;
  }, [componentRef.current]);

  const isPrintable = (number) => {
    if (uncheckedList[number] === undefined) {
      return true;
    }
    return uncheckedList[number];
  };

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: 'AwesomeFileName',
    removeAfterPrint: true,
    onAfterPrint: () => {
      setLoading(false);
      setModalReady(false);
      setUncheckedList([]);
    },
  });

  const handleCheckboxChange = (e, number) => {
    const { checked } = e.target;
    setUncheckedList({ ...uncheckedList, [number]: checked });
  };

  const filterItems = (data) => {
    return data
      .filter((_packageItem) => selectedRowKeys.includes(_packageItem.id))
      .map((packageItem) => {
        const filteredPackageItemSet = packageItem.packageitem_set.filter(
          (item) => item.order_item.product.base_code !== 'codfee'
        );
        return {
          ...packageItem,
          ...filteredPackageItemSet,
        };
      });
  };

  useEffect(() => {
    if (loading && !modalReady) {
      // fetch data
      const { sortOrder, sortField } = sortingFilter;
      request({
        url: createURL(url, [], {
          state: statusId,
          limit: 9999,
          ...queryObject,
          ...(sortOrder
            ? { sort: sortOrder === 'ascend' ? sortField : '-' + sortField }
            : {}),
        }),
        method: 'get',
      }).then((response) => {
        if (response.data && response.data.results) {
          const data = filterItems(response.data.results);

          setData(data);
          setModalReady(true);
        }
      });
    }
  }, [loading, modalReady, statusId]);

  const loadData = () => {
    setLoading(!loading);
  };

  const memoizedGroupedData = useMemo(
    () => groupPackagesByMerchant(data),
    [data]
  );

  const extractAttributes = (product) => {
    const erp_barcode =
      $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.CODE_TO_SCAN.split('.')[1] ||
      $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.CODE_TO_SCAN;
    const {
      epim_merchSubGroupCode,
      integration_merchandisingSubGroup,
      merchandisingSubGroup,
    } = product.attributes;
    const subGroup =
      epim_merchSubGroupCode ||
      integration_merchandisingSubGroup ||
      merchandisingSubGroup ||
      '';
    const colorCode =
      objectSelector(product, $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.COLOR) || '';
    const barcode =
      product.attributes[erp_barcode] || product[erp_barcode] || '';
    const size =
      objectSelector(product, $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.SIZE) || '';
    const sku =
      objectSelector(product, $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT.SKU) || '';
    return { colorCode, subGroup, barcode, size, sku };
  };

  return (
    _content &&
    _content({
      selectedFilterAttrs,
      selectedRowKeys,
      statusId,
      enumValue,
      url,
      sortingFilter,
      componentRef,
      loading,
      modalReady,
      data,
      uncheckedList,
      memoizedGroupedData,
      setLoading,
      setModalReady,
      setUncheckedList,
      isPrintable,
      reactToPrintContent,
      handlePrint,
      handleCheckboxChange,
      filterItems,
      loadData,
      extractAttributes,
    })
  );
};

const mapStateToProps = (state) => ({
  selectedFilterAttrs: state.packageOrderList.selectedFilterAttrs,
});

const mapDispatchToProps = {};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(PrintButton);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/PackageOrderList/printableView/index.js